// 此方法专门用于token的操作
const KEY = 'hmmj-vant-h5-90-token'
// 只需要传入新token
export const setToken = (token) => {
  localStorage.setItem(KEY, token)
}
export const getToken = () => {
  return localStorage.getItem(KEY)
}
export const removeToken = () => {
  localStorage.removeItem(KEY)
  // 不能使用clear方法 它会清除所有的本地存储
}
